import { UIText2 } from '@cian/ui-kit';
import React, { FC } from 'react';
import { TTransportTypes } from 'shared/types/TransportTypes';

import styles from './Transport.css';
import { TransportIcon } from '../TransportIcon';

export type TTransportProps = {
  name: string;
  iconColor: string | null | undefined;
  remoteness: string | null | undefined;
  iconType: TTransportTypes | null | undefined;
};

export const Transport: FC<TTransportProps> = props => {
  const { iconColor, name, remoteness, iconType } = props;

  return (
    <div className={styles['container']} data-testid="metro_block">
      {!!iconColor && !!iconType && (
        <div className={styles['icon']}>
          <TransportIcon iconColor={iconColor} iconType={iconType} />
        </div>
      )}
      <UIText2 display="inline">{name}</UIText2>
      <span className={styles['remoteness']}>
        <UIText2 color="text-secondary-default" display="inline">
          {remoteness}
        </UIText2>
      </span>
    </div>
  );
};
